/**
 * 系统内置方法集，正常情况下您不应该修改或移除此文件
 * */

/**
 * 获取面包屑层级
 * 梁青竹新增
 * */
import { cloneDeep } from 'lodash';

function recursionMenu(menuList, menuLeval, allMenu) {
  menuList && menuList.forEach(function (item) {
    if (item.subMenus === null || item.subMenus === undefined || item.subMenus == '' || item.deep == 3) {
      var cloneMenuLeval = cloneDeep(menuLeval);
      cloneMenuLeval.push({
        menuName: item.menuName,
        menuId: item.menuId
      });
      item.menuLeval = cloneMenuLeval;
      allMenu.push(item);
    } else {
      var _cloneMenuLeval = cloneDeep(menuLeval);

      _cloneMenuLeval.push({
        menuName: item.menuName,
        menuId: item.menuId
      });

      recursionMenu(item.subMenus, _cloneMenuLeval, allMenu);
    }
  });
  return allMenu;
}

function getMenuCrumbs(currentPath, menuList) {
  if (currentPath === '/index/memberCenter') {
    return [{
      menuName: '我的首页',
      menuId: 0
    }];
  }

  var allMenu = recursionMenu(menuList, [], []);
  var pathArr = currentPath.split('/');
  var currentMenuCrumbs = allMenu.find(function (item) {
    if (pathArr.includes('iframe')) {
      // 面包屑兼容显示iframe菜单
      return item.menuCode === pathArr[pathArr.length - 1];
    }

    return item.menuUri.split('#')[1] === currentPath;
  });

  if (currentMenuCrumbs && currentMenuCrumbs.menuLeval && currentMenuCrumbs.menuLeval.length) {
    currentMenuCrumbs.menuLeval[currentMenuCrumbs.menuLeval.length - 1].menuName = currentMenuCrumbs.menuName;
  }

  return currentMenuCrumbs ? currentMenuCrumbs.menuLeval : null;
}

export { getMenuCrumbs };
/**
 * 获取顶部导航名称
 * 梁青竹新增
 * */

function getTopMenuName(currentPath, menuList) {
  return getMenuCrumbs(currentPath, menuList) && getMenuCrumbs(currentPath, menuList)[0].menuName;
}

export { getTopMenuName };
/**
 * @description 根据当前路由，找到菜单名称
 * @param {String} currentPath 当前路径
 * @param {Array} menuList 所有路径
 * */

function getHeaderName(currentPath, menuList) {
  var allMenus = [];
  menuList.forEach(function (menu) {
    var menuName = menu.menuName || '';
    var menus = transferMenu(menu, menuName);
    allMenus.push({
      url: menu.url,
      menuName: menuName
    });
    menus.forEach(function (item) {
      return allMenus.push(item);
    });
  });
  var currentMenu = allMenus.find(function (item) {
    return item.url === currentPath;
  });
  return currentMenu ? currentMenu.menuName : null;
}

function transferMenu(menu, menuName) {
  if (menu.subMenus && menu.subMenus.length) {
    return menu.subMenus.reduce(function (all, item) {
      all.push({
        url: item.path,
        menuName: menuName
      });
      var foundChildren = transferMenu(item, menuName);
      return all.concat(foundChildren);
    }, []);
  } else {
    return [menu];
  }
}

export { getHeaderName };
/**
 * @description 根据当前顶栏菜单 name，找到对应的二级菜单
 * @param {Array} menuList 所有的二级菜单
 * @param {String} headerName 当前顶栏菜单的 name
 * */

function getMenuSider(menuList) {
  var headerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (headerName) {
    return menuList.filter(function (item) {
      return item.header === headerName;
    });
  } else {
    return menuList;
  }
}

export { getMenuSider };
/**
 * @description 根据当前路由，找到其所有父菜单 path，作为展开侧边栏 open-names 依据
 * @param {String} currentPath 当前路径
 * @param {Array} menuList 所有路径
 * */

function getSiderSubmenu(currentPath, menuList) {
  var allMenus = [];
  menuList.forEach(function (menu) {
    var menus = transferSubMenu(menu, []);
    allMenus.push({
      path: menu.path,
      openNames: []
    });
    menus.forEach(function (item) {
      return allMenus.push(item);
    });
  });
  var currentMenu = allMenus.find(function (item) {
    return item.path === currentPath;
  });
  return currentMenu ? currentMenu.openNames : [];
}

function transferSubMenu(menu, openNames) {
  if (menu.children && menu.children.length) {
    var itemOpenNames = openNames.concat([menu.path]);
    return menu.children.reduce(function (all, item) {
      all.push({
        path: item.path,
        openNames: itemOpenNames
      });
      var foundChildren = transferSubMenu(item, itemOpenNames);
      return all.concat(foundChildren);
    }, []);
  } else {
    return [menu].map(function (item) {
      return {
        path: item.path,
        openNames: openNames
      };
    });
  }
}

export { getSiderSubmenu };
/**
 * @description 递归获取所有子菜单
 * */

function getAllSiderMenu(menuList) {
  var allMenus = [];
  menuList.forEach(function (menu) {
    if (menu.children && menu.children.length) {
      var menus = getMenuChildren(menu);
      menus.forEach(function (item) {
        return allMenus.push(item);
      });
    } else {
      allMenus.push(menu);
    }
  });
  return allMenus;
}

function getMenuChildren(menu) {
  if (menu.children && menu.children.length) {
    return menu.children.reduce(function (all, item) {
      var foundChildren = getMenuChildren(item);
      return all.concat(foundChildren);
    }, []);
  } else {
    return [menu];
  }
}

export { getAllSiderMenu };
/**
 * @description 将菜单转为平级
 * */

function flattenSiderMenu(menuList, newList) {
  menuList.forEach(function (menu) {
    var newMenu = {};

    for (var i in menu) {
      if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
    }

    newList.push(newMenu);
    menu.children && flattenSiderMenu(menu.children, newList);
  });
  return newList;
}

export { flattenSiderMenu };
/**
 * @description 判断列表1中是否包含了列表2中的某一项
 * 因为用户权限 access 为数组，includes 方法无法直接得出结论
 * */

function includeArray(list1, list2) {
  var status = false;
  list2.forEach(function (item) {
    if (list1.includes(item)) status = true;
  });
  return status;
}

export { includeArray };